var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'quadro-principal',
    _vm.classe,
    ("borda-esquerda-" + _vm.classe),
    { borderTop: _vm.borderTop },
    { loading: _vm.loading }
  ],style:({ 'min-height': (_vm.minHeight + "px") })},[_c('div',{class:['borda-arredondada', ("borda-direita-" + _vm.classe)]}),_c('h2',{key:_vm.getRenderKey,class:['titulo-lateral', _vm.imprimeTitulo]},[_vm._v(_vm._s(_vm.titulo))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }